import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { LayoutService } from './layout.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CommonModule } from '@angular/common';
import { WorkspaceLayoutComponent } from './layouts/workspace-layout/workspace-layout.component';
import { CartControllerService } from './layouts/workspace-layout/commons/services/cart-controller/cart-controller.service';
import { LoadingComponent } from 'src/app/components/common/loading/loading.component';
import { CanvasControllerService } from '../services/canvas-controller/canvas-controller.service';
@Component({
  selector: 'app-layout',
  imports: [CommonModule, MatButtonToggleModule, WorkspaceLayoutComponent, LoadingComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit, OnDestroy {
  public isDev: boolean = environment.dev;

  public isLoading: boolean = true;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private layoutService: LayoutService,
    private cartController: CartControllerService,
    private canvasController: CanvasControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.cartController.init();
    this.layoutService.isDev = environment.dev;
    this.canvasController.isFirstRendered$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((isFirstRendered) => {
        if (isFirstRendered) {
          this.isLoading = false;
          this.cd.markForCheck();
        }
      });
    this.getBreakpoint();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this._unsubscribeAll.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  private getBreakpoint(): void {
    this.breakpointObserver
      .observe('(orientation: landscape)')
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result) => {
        this.layoutService.deviceMode = result.matches ? 'horizontal' : 'vertical';
        this.cd.markForCheck();
      });
  }
}
